import { WELL_STATUS_COLOR_MAP } from 'utils/well-status';
import { WELL_STATUS_SLOT_CATEGORY_KEYS } from 'utils/slot-categories';
/**
 * Styling for the Subsurface Explorer inset-map well categories (INS-8658).
 *
 * Per Product (Dustin, 2026-06-18): keep wells in their existing status-based
 * colors and differentiate Nearby / Offset by a THICKER line width rather than
 * a distinct color. Offset is drawn thickest (most spacing-relevant); Nearby is
 * thicker than the base wells but thinner than Offset, so the two stay
 * distinguishable (PRD AC 4.3) while still using status colors.
 */

// Status palette as a Mapbox `match` expression so Nearby / Offset wells render
// in the same status colors as the standard wells. The `wells` ES index stores
// `status` UPPERCASE (Well#to_elasticsearch → `status&.upcase`), so we upcase the
// value before matching (also future-proofs against either casing). `PDP` maps
// to producing-blue (see WellsHelper::WELL_STATUS_MAPPING). Unknown / NULL →
// neutral gray (never black).
export const WELL_STATUS_COLOR_MATCH: unknown[] = [
  'match',
  ['upcase', ['to-string', ['get', 'status']]],
  'PRODUCING',
  '#4292c6',
  'PDP',
  '#4292c6',
  'DUC',
  '#fe9929',
  'PERMIT',
  '#ff69b4',
  'SHUT_IN',
  '#555555',
  'EXPIRED_PERMIT',
  '#969696',
  'INACTIVE',
  '#cccccc',
  // The Create New Well statuses, from the shared colour file (INS-13300).
  ...WELL_STATUS_SLOT_CATEGORY_KEYS.flatMap((status) => [
    status.toUpperCase(),
    WELL_STATUS_COLOR_MAP[status],
  ]),
  '#969696', // default (unknown / NULL status)
];

// The subject well is painted black regardless of status (per Product).
export const SUBJECT_COLOR = '#000000';

// Base wells render at line-width ~1.5; these are deliberately thicker.
export const NEARBY_LINE_WIDTH = 3.5;
export const OFFSET_LINE_WIDTH = 3.5;
